import React, { useState, useEffect } from "react";
import { Button } from "../../Components/Login/Button";
import { getMobile } from "../../Redux/Actions/Authentication";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { CheckBoxLogin } from "../../Components/Common/CheckBox";
import InstallPWA from "../../Helpers/InstallPWA";
import pwaInstallPrompt from "pwa-install-prompt";
const Login = ({ ...props }) => {
  const { setPhone, isLogin } = props;
  const [phoneNumber, setPhoneNumber] = useState("");
  const [checked, setChecked] = useState(false);
  const history = useHistory();
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  // const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  // const [isVisible, setVisibleState] = React.useState(false);

  // const hide = () => setVisibleState(false);
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (isLogin) {
      history.push("/Main");
    }

    new pwaInstallPrompt(".pwa-install-prompt__container", {
      active_class: "is-active",
      closer: ".pwa-install-prompt__overlay",
      condition: null,
      expires: 180,
      show_after: 90,
      on: {
        beforeOpen: function () {
          console.log("before open!");
        },
        afterOpen: function () {
          console.log("after open!");
        },
        beforeClose: function () {
          console.log("before close!");
        },
        afterClose: function () {
          console.log("after close!");
        },
      },
    });
  }, []);

  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  return (
    <div className="Container">
      <div className="mobileContainer">
        <div className="LoginPage">
          <img
            src={require("../../assets/images/loginBG@3x.png")}
            // className="LoginBackground"
          />
          <InstallPWA />

          <div>
            <span className="LoginText" id="Billhistory">
              شماره تلفن همراه
            </span>
            <input
              id="Billhistory"
              type="number"
              pattern="[0-9]*"
              autoComplete={false}
              maxLength={11}
              value={phoneNumber}
              onChange={(event) => setPhoneNumber(event.target.value)}
              placeholder={"شماره تلفن همراه خود را وارد نمائید"}
              className="PhoneInput"
            />
            <CheckBoxLogin checked={checked} setChecked={setChecked} />
            <a href="https://dev.mycontor.ir/terms.html" id="Billhistory">
              مشاهده قوانین و مقررات
            </a>
            <Button
              phoneNumber={phoneNumber}
              setPhone={setPhone}
              checked={checked}
            />
            <span
              className="Coop"
              id="MinMaxSpan"
              style={{ animationDelay: "0.5s", opacity: 0 }}
            >
              با همراهی:
            </span>
            <span
              className="Zarin"
              id="MinMaxSpan"
              style={{ animationDelay: "0.5s", opacity: 0 }}
            >
              شرکت گنجینه زرین سپهر
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPhone: (phone) => dispatch(getMobile(phone)),
  };
};
const mapStateToProps = (state) => {
  return {
    mobile: state.auth.mobile,
    isLogin: state.auth.isLogin,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
